/**
 * The no-runner runner, for domains whose work does not execute in a browser.
 *
 * Two real cases today:
 *
 *  * `js_game`, whose graph targets p5.js in the p5 web editor — not one of the
 *    plan's three runners;
 *  * any Python project Pyodide cannot host. A discord.py bot needs real network
 *    and processes, and the pilot learner's current project is exactly that.
 *
 * The architecture does not assume code runs at all; it assumes the work product
 * and the result reach the tutor. So this runner attaches the code and leaves the
 * result to the learner to describe — the pilot's companion mode, kept as a
 * deliberate seam rather than pretended away.
 */

import type { Runner, RunResult } from "./types";

export class CompanionRunner implements Runner {
  readonly id = "none";
  readonly runLabel = "Attach code";
  readonly canStop = false;

  constructor(
    readonly language = "javascript",
    readonly starterCode = "",
  ) {}

  async load(): Promise<void> {
    // Nothing to start.
  }

  async run(): Promise<RunResult> {
    return {
      outcome: "silent",
      detail:
        "Not run here — this one runs on your own machine. Say what happened and " +
        "paste anything it printed.",
    };
  }

  async stop(): Promise<void> {
    // Nothing to stop.
  }

  dispose(): void {
    // Nothing to release.
  }
}
